import { useEffect } from 'react'
import { useTable, usePagination } from 'react-table'
import Pagination from './pagination'

const columns = [{ Header: 'id', accessor: 'id ' }]

const Table = ({
  data,
  filter,
  fetchData,
  loading,
  pageCount: controlledPageCount,
  rowComponent,
  // actions: {
  //   onClickUser,
  //   onClickDelete,
  // }
  curPage = 0,
  perPage = 10,
  noItemsText = 'No result',
}) => {
  // Use the state and functions returned from useTable to build your UI
  const {
    // getTableProps,
    // getTableBodyProps,
    // headerGroups,
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: curPage, pageSize: perPage },
      manualPagination: true,
      pageCount: controlledPageCount,
    },
    usePagination,
  )

  // Listen for changes in pagination and use the state to fetch our new data
  useEffect(() => {
    fetchData({ pageIndex, pageSize, filterData: filter })
  }, [fetchData, pageIndex, pageSize, filter])

  // if (loading && data?.length === 0) {
  //   return <div className='no-result'>
  //     <img src='/account/images/dest/infinity.svg' alt='loading' />
  //   </div>
  // }

  if (loading && data?.length === 0) {
    return <div className="no-result">&nbsp;</div>
  }

  if (!data?.length && !loading) {
    return <div className="no-result">{noItemsText}</div>
  }

  // Render the UI for your table
  return (
    <>
      {page.map((row) => {
        prepareRow(row)
        const item = row.original
        return rowComponent(item)
      })}

      <Pagination
        pageIndex={pageIndex}
        pageSize={pageSize}
        canPreviousPage={canPreviousPage}
        canNextPage={canNextPage}
        pageOptions={pageOptions}
        pageCount={pageCount}
        gotoPage={gotoPage}
        nextPage={nextPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  )
}

export default Table
